import { render } from "./fundAccount.vue?vue&type=template&id=383e83b9&scoped=true"
import script from "./fundAccount.vue?vue&type=script&lang=js"
export * from "./fundAccount.vue?vue&type=script&lang=js"

import "./fundAccount.vue?vue&type=style&index=0&id=383e83b9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383e83b9"]])

export default __exports__